import { getDevBuildLabel } from '../lib/devBuildLabel';

/** Bottom-right GKE DEV stamp. Live GKE has no marker. */
export function DevBuildVersion() {
  const label = getDevBuildLabel();
  if (!label) return null;
  return (
    <p
      className="pointer-events-none fixed bottom-1.5 right-2 z-[100] m-0 text-[10px] leading-none text-sf-gray"
      title={label}
    >
      {label}
    </p>
  );
}
